import React from 'react';
import dynamic from 'next/dynamic';
import useGetApi from '../../../../../hooks/use-get-api';
import { HeroLottieProps } from '../types';

const Lottie = dynamic(() => import('react-lottie'), {
  ssr: false,
});

const HeroLottie: React.FC<HeroLottieProps> = ({ className, id }) => {
  const lottieAnimationUrl =
    'https://assets.clear.in/cleartax/images/1752503096_af_animation.json';
  const { data: lottieAnimationData } = useGetApi(lottieAnimationUrl);

  if (!lottieAnimationData) {
    return null;
  }

  return (
    <div className={className} id={id}>
      <Lottie
        options={{
          loop: false,
          autoplay: true,
          animationData: lottieAnimationData,
          rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice',
            clearCanvas: true,
            progressiveLoad: false,
            hideOnTransparent: true,
          },
        }}
        height="100%"
        width="100%"
      />
    </div>
  );
};

export default HeroLottie;
